import { buildCategoryData } from './commonAnalytics';
import {
  setAdditionalPageInfo,
  setAuthenticationStatus,
  setProfileInfo,
  setb2bProfile,
  setSiteInfo,
  setUserLocalization,
} from './digitalDataBuilder';
import {
  isB2BUser,
  getProfileId,
  getb2bProfile,
  getSiteInfo,
} from './thdUserInfo';

export const initializePageAnalytics = ({
  pageName,
  pageType,
  omnitureInfo,
  storeInfo,
}) => {
  if (typeof window === 'undefined') return;

  if (!window.digitalData) {
    window.digitalData = {};
  }

  const categoryData = buildCategoryData(omnitureInfo);
  setAdditionalPageInfo('category', categoryData);

  const pageInfoData = {
    pageName,
    pageType,
  };
  setAdditionalPageInfo('pageInfo', pageInfoData);

  const authStatus = window.digitalData?.user?.profile?.authenticationStatus || 'guest';
  setAuthenticationStatus(authStatus);

  const profileId = getProfileId();
  if (profileId) {
    setProfileInfo(profileId);
  }

  const b2b = isB2BUser();
  const siteInfo = {
    experienceType: window?.__EXPERIENCE_CONTEXT__?.channel || 'desktop',
    betaSite: getSiteInfo() === 'origin' ? 'prod' : 'beta',
    businessType: b2b ? 'b2b' : 'b2c',
  };
  setSiteInfo(siteInfo);

  if (b2b) {
    const b2bProfile = getb2bProfile();
    setb2bProfile(b2bProfile);
  }

  if (storeInfo) {
    setUserLocalization(storeInfo);
  }
};
